import AuthLayout from "./auth";
import AppLayout from "./app";


export {
    AuthLayout,
    AppLayout
}